export const getTypeFilter = (f) => {
  let result = [];
  if (f.includes("shipment"))
    result = result.concat([
      "not_accepting_goods",
      "address_changed",
      "stuck_order",
      "failed_pickup",
      "oversla",
      "tracking_not_updated",
      "weight_or_payment_discrepancy",
    ]);
  if (f.includes("cashOnDelivery"))
    result = result.concat(["cod_disbursement", "cod_disbursement_order_status_not_delivered"]);
  if (f.includes("dashboard")) result = result.concat(["error_dashboard", "wallet_dashboard"]);
  if (f.includes("retur"))
    result = result.concat([
      "return_recipient_not_placing_order",
      "return_recipient_not_in_place",
      "return_recipient_cannot_contacted",
      "return_address_not_found",
      "return_oversla",
      "return_recipient_not_receiving_package",
    ]);
  if (f.includes("claim"))
    result = result.concat(["claim_package_lost", "claim_package_broken", "claim_oversla"]);
  if (f.includes("inquiry")) result = result.concat(["inquiry"]);
  if (f.includes("integrationAPI"))
    result = result.concat([
      "api_rates_not_working",
      "api_tracking_not_working",
      "api_orders_not_working",
      "webhook_not_working",
    ]);
  if (f.includes("integrationGudang")) result = result.concat(["integration_gudang"]);
  if (f.includes("integrationShopify"))
    result = result.concat([
      "cannot_activate_shopify_plugin",
      "cannot_import_shopify_orders_express_courier",
      "cannot_import_shopify_orders_instant_courier",
    ]);
  if (f.includes("integrationWoo"))
    result = result.concat([
      "woocommerce_checkout_page",
      "cannot_generate_woocommerce_awb",
      "cannot_activate_woocommerce_plugin",
    ]);

  return result;
};

export const initialStatusFilter = {
  active: {
    selected: false,
    count: 0,
  },
  processing: {
    selected: false,
    count: 0,
  },
  solved: {
    selected: false,
    count: 0,
  },
};

export const initialTypeFilter = {
  shipment: {
    selected: false,
    count: 0,
  },
  cashOnDelivery: {
    selected: false,
    count: 0,
  },
  retur: {
    selected: false,
    count: 0,
  },
  claim: {
    selected: false,
    count: 0,
  },
};

export const firstCategoryOptions = [
  { title: "Penjemputan/ Pengiriman", value: "shipment" },
  { title: "Cash On Delivery (COD)", value: "cashOnDelivery" },
  { title: "Dasbor", value: "dashboard" },
  { title: "Retur", value: "retur" },
  { title: "Klaim Paket Hilang/ Rusak", value: "claim" },
  { title: "Pertanyaan", value: "inquiry" },
  { title: "Integrasi API", value: "integrationAPI" },
  { title: "Integrasi Gudang.io", value: "integrationGudang" },
  { title: "Integrasi Shopify", value: "integrationShopify" },
  { title: "Integrasi Woocommerce", value: "integrationWoo" },
];

// NOTE: It is better to initialize it first.
export const shipmentOptions = [
  {
    title: "Tidak Merasa Menerima Paket",
    value: "not_accepting_goods",
    firstCategoryValue: "shipment",
  },
  {
    title: "Ganti Alamat",
    value: "address_changed",
    firstCategoryValue: "shipment",
  },
  {
    title: "Pesanan Stuck",
    value: "stuck_order",
    firstCategoryValue: "shipment",
  },
  {
    title: "Paket Belum Dijemput/ Gagal Pick-Up",
    value: "failed_pickup",
    firstCategoryValue: "shipment",
  },
  {
    title: "Pengiriman Lewat Estimasi (Over SLA)",
    value: "oversla",
    firstCategoryValue: "shipment",
  },
  {
    title: "Status Pesanan Tidak Update",
    value: "tracking_not_updated",
    firstCategoryValue: "shipment",
  },
  {
    title: "Selisih Berat/ Pembayaran",
    value: "weight_or_payment_discrepancy",
    firstCategoryValue: "shipment",
  },
];

export const cashOnDeliveryOptions = [
  {
    title: "Pencairan Dana COD",
    value: "cod_disbursement",
    firstCategoryValue: "cashOnDelivery",
  },
  {
    title: "Status Pesanan Belum Delivered",
    value: "cod_disbursement_order_status_not_delivered",
    firstCategoryValue: "cashOnDelivery",
  },
];

export const dashboardOptions = [
  {
    title: "Dasbor Error",
    value: "error_dashboard",
    firstCategoryValue: "dashboard",
  },
  {
    title: "Saldo Bite Points",
    value: "wallet_dashboard",
    firstCategoryValue: "dashboard",
  },
];

export const returOptions = [
  {
    title: "Penerima Retur Tidak Merasa Mengirim Barang",
    value: "return_recipient_not_placing_order",
    firstCategoryValue: "retur",
  },
  {
    title: "Penerima Retur Tidak Ditempat",
    value: "return_recipient_not_in_place",
    firstCategoryValue: "retur",
  },
  {
    title: "Penerima Retur Tidak Dapat Dihubungi",
    value: "return_recipient_cannot_contacted",
    firstCategoryValue: "retur",
  },
  {
    title: "Alamat Retur Tidak Ditemukan",
    value: "return_address_not_found",
    firstCategoryValue: "retur",
  },
  {
    title: "Pengiriman Retur Lewat Estimasi (Over SLA)",
    value: "return_oversla",
    firstCategoryValue: "retur",
  },
  {
    title: "Tidak Merasa Menerima Paket Retur",
    value: "return_recipient_not_receiving_package",
    firstCategoryValue: "retur",
  },
];

export const claimOptions = [
  {
    title: "Klaim Paket Hilang",
    value: "claim_package_lost",
    firstCategoryValue: "claim",
  },
  {
    title: "Klaim Paket Rusak",
    value: "claim_package_broken",
    firstCategoryValue: "claim",
  },
  {
    title: "Klaim Pengiriman Lewat Estimasi (Over SLA)",
    value: "claim_oversla",
    firstCategoryValue: "claim",
  },
];

export const inquiryOptions = [
  { title: "Pertanyaan", value: "inquiry", firstCategoryValue: "inquiry" },
];

export const integrationAPIOptions = [
  {
    title: "API Rates Tidak Berfungsi",
    value: "api_rates_not_working",
    firstCategoryValue: "integrationAPI",
  },
  {
    title: "API Tracking Tidak Berfungsi",
    value: "api_tracking_not_working",
    firstCategoryValue: "integrationAPI",
  },
  {
    title: "API Orders Tidak Berfungsi",
    value: "api_orders_not_working",
    firstCategoryValue: "integrationAPI",
  },
  {
    title: "Webhook Tidak Berfungsi",
    value: "webhook_not_working",
    firstCategoryValue: "integrationAPI",
  },
];

export const integrationGudangOptions = [
  {
    title: "Integrasi Gudang.io Bermasalah",
    value: "integration_gudang",
    firstCategoryValue: "integrationGudang",
  },
];

export const integrationShopifyOptions = [
  {
    title: "Tidak Dapat Mengaktifkan Plugin Shopify",
    value: "cannot_activate_shopify_plugin",
    firstCategoryValue: "integrationShopify",
  },
  {
    title: "Tidak Dapat Import Pesanan Kurir Reguler Shopify",
    value: "cannot_import_shopify_orders_express_courier",
    firstCategoryValue: "integrationShopify",
  },
  {
    title: "Tidak Dapat Import Pesanan Kurir Instant Shopify",
    value: "cannot_import_shopify_orders_instant_courier",
    firstCategoryValue: "integrationShopify",
  },
];

export const integrationWooOptions = [
  {
    title: "Halaman Checkout Woocommerce Bermasalah",
    value: "woocommerce_checkout_page",
    firstCategoryValue: "integrationWoo",
  },
  {
    title: "Tidak Dapat Membuat Resi Woocommerce",
    value: "cannot_generate_woocommerce_awb",
    firstCategoryValue: "integrationWoo",
  },
  {
    title: "Tidak Dapat Mengaktifkan Plugin Woocommerce",
    value: "cannot_activate_woocommerce_plugin",
    firstCategoryValue: "integrationWoo",
  },
];

export const secondCategoryOptions = (value) => {
  switch (value) {
    case "shipment":
      return shipmentOptions;
    case "cashOnDelivery":
      return cashOnDeliveryOptions;
    case "dashboard":
      return dashboardOptions;
    case "retur":
      return returOptions;
    case "claim":
      return claimOptions;
    case "inquiry":
      return inquiryOptions;
    case "integrationAPI":
      return integrationAPIOptions;
    case "integrationGudang":
      return integrationGudangOptions;
    case "integrationShopify":
      return integrationShopifyOptions;
    case "integrationWoo":
      return integrationWooOptions;
    default:
      return shipmentOptions.concat(
        cashOnDeliveryOptions,
        dashboardOptions,
        returOptions,
        claimOptions,
        inquiryOptions,
        integrationAPIOptions,
        integrationGudangOptions,
        integrationShopifyOptions,
        integrationWooOptions
      );
  }
};
